import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=42754cb2"
var script = {}
import style0 from "./LayoutAuth.vue?vue&type=style&index=0&id=42754cb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports